// src/personal/SchoolDesk.js
import React, {useState, useEffect} from "react";
import {firestore} from "../firebase";
import {
  collection,
  getDocs,
  query,
  where,
  limit,
} from "firebase/firestore";
//import { Timestamp } from "firebase/firestore";
import {useAuth} from "../contexts/AuthContext";
import {Link} from "react-router-dom";
import {Button} from "react-bootstrap";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {
  faHomeAlt,
} from "@fortawesome/free-solid-svg-icons";
import "./School.css";

const SchoolDesk = () => {
  const [desks, setdesks] = useState([]);
  const [error, setError] = useState("");
  const {currentUser} = useAuth();

  //console.log("uid : ", currentUser.uid);

  // 한달 주문내역만 조회 가능, 10개 제한
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
  //const startTimestamp = Timestamp.fromDate(oneMonthAgo);

  useEffect(() => {
    const fetchdesks = async () => {
      try {
        const q = query(
          collection(firestore, "payments"),
          where("user_id", "==", currentUser.uid),
          where("status", "in", ["completed", "cancelled"]),
          //where("dt", ">=", startTimestamp),
          //orderBy("dt", "desc"),
          limit(10)
        );
        const querySnapshot = await getDocs(q);
        const deskData = [];
        querySnapshot.forEach((docSnapshot) => {
          const data = docSnapshot.data();
          const date = new Date(data.created_at.seconds * 1000 + data.created_at.nanoseconds / 1000000);
          deskData.push({id: docSnapshot.id, ...data, created_at: date});
        });
        setdesks(deskData);

        //console.log("data : ", deskData);
      } catch (error) {
        console.error("Error fetching desks: ", error);
        setError(error);
      }
    };

    fetchdesks();
  }, [currentUser.uid]);

  return (
    <section className="container-fluid position-relative overflow-hidden pt-5 pt-lg-3">
      <div className="mx-auto">
        <h2>주문 결제 내역</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 mb-4">

          {error && <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">{error}</div>}

          <ol>
            <div className="row g-4 justify-content-center">
              {desks.map((desk) => (
                <div key={desk.id} className="col-sm-6 col-lg-4 col-xl-3">
                  <div className="card">
                    <div className="card-body">
                      <div className="desk-info py-2" style={{textAlign: "left"}}>
                        <li> 라이선스 : {desk.item_name} </li>
                      </div>
                      <div className="text-primary" style={{textAlign: "left"}}>
                        <ol>
                          <li>가격 : {desk.total_amount} 원</li>
                          <li>수량 : {desk.quantity} 개</li>
                          <li>주문번호 : {desk.id}</li>
                          <li>결제방식 :
                            {desk.payment_method_type === "MONEY" && "카카오페이머니"}
                            {desk.payment_method_type === "CARD" && "신용/체크카드"}
                            {desk.payment_method_type === "BANK" && "계좌이체"}
                            {desk.payment_method_type === "POINT" && "카카오페이포인트"}
                            {desk.payment_method_type === "PAYPAL" && "페이팔"}
                            {desk.payment_method_type === "MOBILE" && "휴대폰결제"}
                            {desk.payment_method_type === "GIFTCARD" && "상품권"}
                            {desk.payment_method_type !== "MONEY" &&
                                desk.payment_method_type !== "CARD" &&
                                desk.payment_method_type !== "BANK" &&
                                desk.payment_method_type !== "POINT" &&
                                desk.payment_method_type !== "PAYPAL" &&
                                desk.payment_method_type !== "MOBILE" &&
                                desk.payment_method_type !== "GIFTCARD" &&
                                desk.payment_method_type}
                          </li>
                          <li>결제ID : {desk.tid}</li>
                          <li>
                            결제일시 :
                            {desk.created_at.toLocaleString("ko-KR", {
                              timeZone: "Asia/Seoul",
                            })}
                          </li>
                          <li>결제상태 : {desk.status === "completed" && "완료"}
                            {desk.status === "cancelled" && "취소"}
                            {desk.status !== "completed" && desk.status !== "cancelled" && "미완료"}
                          </li>
                        </ol>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </ol>
        </div>

        <Link to="/newSchool" className="row g-4 justify-content-center mb-3">
          <Button
            variant="primary"
            size="lg"
            className="card-img-top mt-4 w-auto px-5 py-2"
          >
            <FontAwesomeIcon icon={faHomeAlt} className="me-2" />
            학교 메뉴
          </Button>
        </Link>
      </div>
    </section>
  );
};

export default SchoolDesk;
